import type { Path } from 'react-hook-form';
// eslint-disable-next-line lodash/import-scope
import type { GetFieldType } from 'lodash';
import Get from 'lodash/get';

export const getUniqueValues = <T, K extends Path<T>>(
  data: T[],
  key: K
): GetFieldType<T, K, 'Path'>[] =>
  Array.from(new Set(data.map((j) => Get(j, key))));
